import AxiosInstance from "./AxiosInstance";

export const getAllTravelPartner = async () => {
  try {
    const { data } = await AxiosInstance.get("/travel_partner");
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const createTravelPartner = async (partnerData) => {
  try {
    const { data } = await AxiosInstance.post("/travel_partner", partnerData);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const updateTravelPartner = async (id, partnerData) => {
  try {
    const { data } = await AxiosInstance.put(`/travel_partner`, { id, ...partnerData });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteTravelPartner = async (id) => {
  try {
    const { data } = await AxiosInstance.delete(`/travel_partner/${id}`);
    return data;
  } catch (error) {
    console.log(error);
  }
};
